import CaseStudiesCarousel from './CaseStudiesCarousel';

export default CaseStudiesCarousel;
